import type { ReactNode } from 'react';

// Barra fixa do rodapé: campo de respiro + área segura do celular.
export default function RodapeFixo({ children }: { children: ReactNode }) {
  return (
    <div className="fixed inset-x-0 bottom-0 z-40 border-t border-background-200 bg-background-50/95 backdrop-blur-md">
      <div className="mx-auto w-full max-w-[560px] px-4 pb-[max(12px,env(safe-area-inset-bottom))] pt-3">
        {children}
      </div>
    </div>
  );
}